export const USER_ROLE = {
  OWNER: 'Owner',
  ADMIN: 'Admin',
  VIEW_ONLY: 'view-only', // to confirm with Backend again when start feature
};
